
var lib_geometry = require("lib-geometry");
var TextMeshHelper = require("./textMeshHelper");

var PropertyToMesh = function(){

    this.mesh = this.deepCachedFunction("mesh", 
        function(info){ 
            var silkscreenHeight = (info && info.silkscreenHeight)? info.silkscreenHeight : 1;
            var silkscreenEndSegments = (info && info.silkscreenEndSegments)? info.silkscreenEndSegments : 3;
            var holes = (info && info.holes)? info.holes : [];
            var boardThickness = (info && info.boardThickness)? info.boardThickness : 2;
            
            var mesh = TextMeshHelper(this.textData(), holes, silkscreenHeight, silkscreenEndSegments, '>'+this.textData().text());

            var layeredShapeData = this.parent().layerIndex ? this.parent() : this.parent().parent();
            if(layeredShapeData && layeredShapeData.layerIndex.contains(1)){
                mesh.translate(0,0, -boardThickness - silkscreenHeight);
            }

            return mesh;

        },
        [[this.textData, this.textData.onBubble]], 1
    );
}
 

module.exports = PropertyToMesh;